export default __webpack_public_path__ + "static/media/Política de Privacidade - Muron.91327ed2.pdf";